module.exports = __webpack_public_path__ + "static/img/loading-square.b0fda8f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/site/loading-square.gif
// module id = EYp+
// module chunks = 17